module.exports = __webpack_public_path__ + "static/media/mobile.e5807f80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile.jpg
// module id = 1178
// module chunks = 33